(function () {
  if (window.etellSectionsV42) return;
  window.etellSectionsV42 = true;
  const instances = new Map();

  function mount(root, kind) {
    if (instances.has(root)) return;
    const craft = kind === 'craft';
    const hero = kind === 'hero';
    const track = craft ? root.querySelector('[data-craft-track]') : null;
    const slides = Array.from(root.querySelectorAll(craft ? '.etell-craft__card' : hero ? '.etell-hero__slide' : '[data-slide]'));
    if (slides.length < 2 || (craft && !track)) return;
    const controller = new AbortController();
    const listen = function (target, event, callback, options) {
      if (target) target.addEventListener(event, callback, Object.assign({}, options, { signal: controller.signal }));
    };
    let current = 0, timer = null, scrollTimer = null, startX = 0, hovered = false;
    const delay = Math.max(1000, Number(root.dataset.delay) || 6000);
    const autoplay = (hero || craft ? root.dataset.autoplay : root.dataset.auto) === 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    let dots;
    if (!hero && !craft) {
      const wrap = root.querySelector('[data-dots]');
      if (!wrap) return;
      wrap.replaceChildren();
      slides.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Ir a imagen ' + (index + 1));
        wrap.appendChild(dot);
      });
      dots = Array.from(wrap.querySelectorAll('button'));
    } else {
      dots = Array.from(root.querySelectorAll(craft ? '[data-craft-dot]' : '.etell-hero__dot'));
    }
    function updateDots() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
        dot.setAttribute('aria-pressed', String(index === current));
      });
    }
    function show(index) {
      if (craft && !mobile.matches) return;
      current = (index + slides.length) % slides.length;
      if (craft) {
        const left = track.scrollLeft + slides[current].getBoundingClientRect().left - track.getBoundingClientRect().left - 20;
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      }
      updateDots();
    }
    function stop() { if (timer !== null) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (autoplay && !document.hidden && !hovered && (!craft || mobile.matches)) timer = setInterval(function () { show(current + 1); }, delay);
    }
    dots.forEach(function (dot, index) { listen(dot, 'click', function () { show(index); start(); }); });
    if (hero) {
      listen(root, 'touchstart', function (event) { startX = event.touches[0].clientX; stop(); }, { passive: true });
      listen(root, 'touchend', function (event) {
        const distance = event.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
        start();
      }, { passive: true });
      listen(root, 'touchcancel', start, { passive: true });
      listen(root, 'mouseenter', function () { hovered = true; stop(); });
      listen(root, 'mouseleave', function () { hovered = false; start(); });
    } else if (craft) {
      listen(track, 'scroll', function () {
        if (!mobile.matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          const bounds = track.getBoundingClientRect();
          const center = bounds.left + bounds.width / 2;
          let best = 0, distance = Infinity;
          slides.forEach(function (card, index) {
            const cardBounds = card.getBoundingClientRect();
            const nextDistance = Math.abs(cardBounds.left + cardBounds.width / 2 - center);
            if (nextDistance < distance) { distance = nextDistance; best = index; }
          });
          current = best; updateDots();
        }, 90);
      }, { passive: true });
      listen(track, 'touchstart', stop, { passive: true });
      listen(track, 'touchend', start, { passive: true });
      listen(track, 'touchcancel', start, { passive: true });
      listen(mobile, 'change', start);
    } else {
      listen(root.querySelector('[data-prev]'), 'click', function () { show(current - 1); start(); });
      listen(root.querySelector('[data-next]'), 'click', function () { show(current + 1); start(); });
    }
    listen(document, 'visibilitychange', function () { if (document.hidden) stop(); else start(); });
    listen(window, 'pagehide', stop);
    listen(window, 'pageshow', start);
    instances.set(root, function () { controller.abort(); stop(); clearTimeout(scrollTimer); });
    if (craft) updateDots(); else show(0);
    start();
  }
  function init(scope) {
    [['[data-etell-hero]', 'hero'], ['.etell-video-block [data-slider]', 'video'], ['[data-craft-slider]', 'craft']].forEach(function (entry) {
      if (scope.matches && scope.matches(entry[0])) mount(scope, entry[1]);
      scope.querySelectorAll(entry[0]).forEach(function (root) { mount(root, entry[1]); });
    });
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) {
      if (event.target === root || event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
